export default __webpack_public_path__ + "images/e8a9bd0221f637297ef711da73524c81-NoContentIcon.svg";